import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timePeriod',
    standalone: false
})
export class TimePeriodPipe implements PipeTransform {
  transform(totalSeconds: number, fractionDigits: number = 0) {
    if (totalSeconds == null || isNaN(totalSeconds)) {
      return '';
    }
    const format = (s: number) =>
      fractionDigits > 0 ? s.toFixed(fractionDigits) : Math.floor(s).toString();

    if (totalSeconds >= 60) {
      const minutes = Math.floor(totalSeconds / 60);
      return minutes.toString() + 'm ' + format(totalSeconds - minutes * 60) + 's';
    }
    else {
      return format(totalSeconds) + 's';
    }
  }
}
